// extracted by mini-css-extract-plugin
export default {"sectionSelector":"AnimateFromBottom_sectionSelector__X6TWx","component":"AnimateFromBottom_component__ESdRE","center":"AnimateFromBottom_center__wvDJf"};